import styles from "./DeviceSearchHeader.module.scss";
export const DeviceSearchHeader = () => {
  return <h2 className={styles.deviceSearchHeader}>Find your device model</h2>;
};
